import * as actions from "../actions"
import { getDataUrl, getUrl, getUploadUrl } from "./mangrove"

export function deleteContent(server, parameters) {
  const functionName = "myfloodrisk.appfunctions.DeleteContent"
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return fetch(url)
      .then(response => response.json())
      .then(json => { return json })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function deleteContent`, type: "error", duration: 4000 } })
      })
  }
}

export function deleteLayers(server, parameters) {
  const functionName = "myfloodrisk.appfunctions.DeleteLayer"
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => { return json })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function deleteLayers`, type: "error", duration: 4000 } })
      })
  }
}

export function getContent(server, parameters, contentType) {
  const functionName = "myfloodrisk.appfunctions.GetContent"
  const url = getDataUrl(server, functionName, parameters, contentType)

  if (process.env.REACT_APP_TYPE === "app") {
    return async function (dispatch) {
      return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest()
        xhr.onload = function () {
          resolve(xhr.responseText)
        }
        xhr.open("GET", url)
        xhr.send(null)
      })
    }
  } else {
    return async function (dispatch) {
      return await fetch(url)
        .then(response => response.text())
        .then(text => { return text })
        .catch(function (error) {
          dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function getContent`, type: "error", duration: 4000 } })
        })
    }
  }
}

export function getRainfallForecast(server) {
  const functionName = "myfloodrisk.appfunctions.GetRainfallForecast"
  const url = getUrl(server, functionName, {})

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        dispatch(setRainfallForecastInState(json))
        return json
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function getRainfallForecast`, type: "error", duration: 4000 } })
      })
  }
}

export function getScheduledNotifications(server, parameters) {
  const functionName = "myfloodrisk.appfunctions.GetScheduledNotifications"
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        dispatch(setScheduledNotificationsinState(json))
        return json
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function getScheduledNotifications`, type: "error", duration: 4000 } })
      })
  }
}

export function getSlides(server, parameters) {
  const functionName = "myfloodrisk.appfunctions.GetSlides"
  const url = getUrl(server, functionName, parameters)

  if (process.env.REACT_APP_TYPE === "app") {
    return async function (dispatch) {
      return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest()
        xhr.onload = function () {
          resolve(xhr.responseText)
        }
        xhr.open("GET", url)
        xhr.send(null)
      })
    }
  } else {
    return async function (dispatch) {
      return await fetch(url)
        .then(response => response.json())
        .then(json => { return json })
        .catch(function (error) {
          dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function getSlides`, type: "error", duration: 4000 } })
        })
    }
  }
}

export function UploadImageToServer(file, name) {
  return async function (dispatch) {
    const uploadUrl = getUploadUrl("tsws")
    const formData = new FormData()
  
    const parameters = {
      appid: 42,
      key: name,
      plain: true
    }
  
    formData.append("File", file)
    formData.append("function", "myfloodrisk.appfunctions.SetImage")
    formData.append("parameters", JSON.stringify(parameters))
  
    return await fetch(uploadUrl,
      {
        method: "POST",
        body: formData
      })
      .then((response) => response.json())
      .then((json) => {
        return json 
      })
      .catch((error) => {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function SetImage`, type: "error", duration: 4000 } })
      })
  }
}

export function setLayer(server, parameters) {
  const functionName = "myfloodrisk.appfunctions.SetLayer"
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return fetch(url)
      .then(response => response.json())
      .then(json => { return json })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function setLayer`, type: "error", duration: 4000 } })
      })
  }
}

export function addScheduledNotification(server, parameters) {
  const functionName = "myfloodrisk.appfunctions.AddScheduledNotification"
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        return json
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function addScheduledNotification`, type: "error", duration: 4000 } })
      })
  }
}

export function setRainfallForecastInState(forecast) {
  return {
    type: actions.SET_RAINFALLFORECAST,
    forecast
  }
}

export function setScheduledNotificationsinState(notifications) {
  return {
    type: actions.SET_SCHEDULED_NOTIFICATIONS,
    notifications
  }
}
